export type Voice = {
    voice_id: string;
    name: string;
    category: string;
    accent: string;
    descriptive: string;
    age: string;
    gender: string;
    language: string;
    use_case: string;
    description: string;
    preview_url: string;
};

export enum ContentEditSegment {
    Unsubscribed = 'unsubscribed',
    SubscribedUser = 'subscribed_user',
    UpgradableUser = 'upgradable_user',
    Disabled = 'disabled',
}
